// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"5f4a92d8","776":"3f6b84b4"}[chunkId] + ".chunk.js";
};